import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const ciudades = `${baseUrl}/ubigeo/ciudades`;

export const allCiudadesService = async (estado) => {
  try {
    const res = await axios.get(ciudades, {
      headers: token({}),
      params: {
        estado,
      },
    });
    return res;
  } catch (e) {
    console.log(e);
  }
};
